import styled from 'styled-components';
import { LinkButton } from '../../Toolkit/Button/LinkButton';
import { Text } from '../../ToolkitV2/Text/Text';

export const Container = styled.span`
  display: inline-flex;
  align-items: center;
  gap: ${({ theme }) => theme.donedeal.spacing.S4};
`;

export const IconWrapper = styled.span`
  display: flex;
`;

// TODO: Should the dashed underline and relevant hover styles be baked into link button?
export const TriggerContainer = styled(LinkButton)`
  display: inline-flex;
  align-items: center;
  gap: ${({ theme }) => theme.donedeal.spacing.S4};

  &:hover,
  &:focus-visible {
    text-decoration: none;
  }
`;

export const TriggerText = styled(Text)`
  border-bottom: 1px dashed ${({ theme }) => theme.donedeal.colors.GREY};
`;
